'use strict';

;(function($) {

  const map = document.querySelector('#map');
  var marker = null;
  var infowindow = null;

  function initialize() {
    var lat, lng;
    var geocoder;
    var address = $('#map').data('address');
    var title = $('#map').data('title');

    $.ajax({
      url: 'https://maps.googleapis.com/maps/api/geocode/json?address=' + address
    }).done(function( data ) {

      lat = data.results[0].geometry.location.lat;
      lng = data.results[0].geometry.location.lng;

      var mapCanvas = document.getElementById('map');

      var mapOptions = {
        center: new google.maps.LatLng(lat, lng),
        zoom: 14,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
      }

      var map = new google.maps.Map(mapCanvas, mapOptions);

      var contentString = '';
      contentString += '<h4>' + title + '</h4>';
      contentString += '<p>' + data.results[0].formatted_address + '</p>';

      infowindow = new google.maps.InfoWindow({
        content: contentString
      });

      marker = new google.maps.Marker({
        position: new google.maps.LatLng(lat, lng),
        map: map,
        title: title
      });

      marker.addListener('click', function() {
        infowindow.open(map, marker);
      });

      infowindow.open(map, marker);
    });
  }

  if(map) {
    google.maps.event.addDomListener(window, 'load', initialize);
  }

})(jQuery);
